import { useSelector } from 'react-redux';
import { FiltersListItem as FiltersListItemView } from '../components/FiltersListItem';

export function FiltersListItem({
    activeFilter,
    filter,
    theme,
    onClick,
    onFilterCloseClick
}) {
    const activeFilters = useSelector(({ filters }) => filters.activeFilters);
    const sizeFiltersGroups = useSelector(({ filters }) => filters.dropdownFilters.size?.groups);
    const activeCount = activeFilters ? activeFilters.filter(({ filterType }) => filterType === filter.type).length : 0;

    const handleClick = (event) => {
        event.preventDefault();
        onClick(filter);
    };

    return (
        <FiltersListItemView
            activeFilter={activeFilter}
            count={activeCount}
            filter={filter}
            isMultiColumnSizeFilter={sizeFiltersGroups?.length > 1}
            theme={theme}
            onClick={handleClick}
            onFilterCloseClick={onFilterCloseClick}
        />
    );
}
